// extracted by mini-css-extract-plugin
export var form = "_7ebf9a6789a965d0beb0227f7605b51a-css";